import { cn } from '~/lib/utils';
import LogoDark from '~/assets/logo-dark.svg';
import LogoLight from '~/assets/logo-light.svg';
import { useTheme } from '~/contexts/ThemeContext';
interface GlobalSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}
export default function GlobalSpinner({
  className,
  size = 'lg',
  label,
}: GlobalSpinnerProps) {
  const sizeMap = { sm: 'h-12 w-12', md: 'h-16 w-16', lg: 'h-24 w-24' };
  const { theme } = useTheme();
  return (
    <div
      role="status"
      aria-label={label ?? 'Loading'}
      className={cn(
        'flex flex-col items-center justify-center h-svh w-full space-y-4 bg-muted-foreground/10',
        className,
      )}
    >
      <div className="relative flex items-center justify-center">
        <div className="p-6 rounded-full relative">
          <div
            className={cn(
              'absolute inset-0 border-4 border-primary/20 flip-ring',
              'rounded-[50%_20%_50%_20%]',
              'rotate-45',
            )}
          />
          <div
            className={cn(
              'absolute inset-0 border-4 border-primary/20 flip-ring',
              'rounded-[50%_20%_50%_20%]',
              '-rotate-45',
            )}
          />
          <img
            src={theme === 'dark' ? LogoLight : LogoDark}
            alt="App Logo"
            className={cn(
              'relative z-10 drop-shadow-sm object-contain',
              sizeMap[size],
            )}
          />
        </div>
      </div>
      {label && (
        <p className="text-sm text-muted-foreground animate-pulse">{label}</p>
      )}
    </div>
  );
}
